import { isLoggedIn } from './isLoggedIn';
import { preloadUrlHash } from './preloadUrlHash';
import { Routes } from './Routes';
import { makeUrl } from './makeUrl';
import { Queries } from './quick-queries';
import type { PreloadDefintion } from './quickload.types';

export const getQuickloadUrls = (
  path: string = window.location.pathname,
): PreloadDefintion[] => {
  if (!isLoggedIn()) {
    return [];
  }

  const preloadKeyMatch = Object.keys(preloadUrlHash).find((routeRegExp) =>
    new RegExp(routeRegExp).test(path),
  ) as Routes;
  const preloadMatch = preloadKeyMatch && preloadUrlHash[preloadKeyMatch];

  const memberHeaderUrl: PreloadDefintion = [
    makeUrl('/1/Members/me', Queries.memberHeader),
    'quick-queries:memberHeader',
  ];

  if (!preloadMatch) {
    return [memberHeaderUrl];
  }

  return [memberHeaderUrl].concat(preloadMatch.getUrls(path));
};
